import type { Answers, StoredResult } from '../types'

export const CONTENT_VERSION = '2.0-frozen'

export const STORAGE_KEYS = {
  activated: 'soulfilm:v2:activated',
  answers: 'soulfilm:v2:answers',
  currentQuestion: 'soulfilm:v2:currentQuestion',
  result: 'soulfilm:v2:result',
  contentVersion: 'soulfilm:v2:contentVersion',
} as const

export interface SessionSnapshot {
  activated: boolean
  answers: Answers
  currentQuestion: number
  result: StoredResult | null
}

function readJson<T>(key: string, fallback: T): T {
  try {
    const value = localStorage.getItem(key)
    return value ? (JSON.parse(value) as T) : fallback
  } catch {
    return fallback
  }
}

export function loadSession(): SessionSnapshot {
  const activated = localStorage.getItem(STORAGE_KEYS.activated) === 'true'
  const storedVersion = localStorage.getItem(STORAGE_KEYS.contentVersion)
  if (storedVersion !== CONTENT_VERSION) {
    localStorage.removeItem(STORAGE_KEYS.answers)
    localStorage.removeItem(STORAGE_KEYS.currentQuestion)
    localStorage.removeItem(STORAGE_KEYS.result)
    localStorage.setItem(STORAGE_KEYS.contentVersion, CONTENT_VERSION)
    return { activated, answers: {}, currentQuestion: 0, result: null }
  }

  return {
    activated,
    answers: readJson<Answers>(STORAGE_KEYS.answers, {}),
    currentQuestion: Math.max(
      0,
      Number(localStorage.getItem(STORAGE_KEYS.currentQuestion) ?? 0) || 0,
    ),
    result: readJson<StoredResult | null>(STORAGE_KEYS.result, null),
  }
}

export function saveSession(snapshot: SessionSnapshot) {
  localStorage.setItem(STORAGE_KEYS.activated, String(snapshot.activated))
  localStorage.setItem(STORAGE_KEYS.answers, JSON.stringify(snapshot.answers))
  localStorage.setItem(STORAGE_KEYS.currentQuestion, String(snapshot.currentQuestion))
  localStorage.setItem(STORAGE_KEYS.result, JSON.stringify(snapshot.result))
  localStorage.setItem(STORAGE_KEYS.contentVersion, CONTENT_VERSION)
}
